module.exports = __webpack_public_path__ + "img/regulatory-one.7357ae54.png";